import { render, staticRenderFns } from "./SuspenseImg.vue?vue&type=template&id=7050cb5c"
import script from "./SuspenseImg.vue?vue&type=script&lang=js"
export * from "./SuspenseImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports